export default __webpack_public_path__ + "static/media/Frame 22.818a2691.svg";